import React from 'react';
import MonoboxData from '../MonoboxData';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { getItemVariantsString, getProductImageUrl } from '../../../../helpers';

const HeaderWrapper = styled.div`
  padding: 28px 16px 16px;
  margin: 0 -22px;
  position: relative;

  .back-link {
    color: inherit;
    position: absolute;
    font-size: 16px;
    right: 16px;
    top: 15px;
    line-height: 100%;
  }

  .page-title {
    margin: 0 0 5px;
    max-width: calc(100% - 28px);
  }
`;

const Wrapper = styled('div')`
  margin: 0 -22px;

  .card-box {
    border-radius: unset;
    box-shadow: none;
    width: 100%;

    .product-link {
      display: grid;
      grid-template-areas: 'i h' 'i v';
      grid-column-gap: 16px;

      .product-image {
        grid-area: i;
        width: 100px;
      }

      .header-title {
        margin-top: 10px;
      }
    }
  }

  .variant-data-buttons {
    display: flex;
    padding: 0 16px 16px;
  }
`;

const MobileLayout = (props) => {
  const {
    pageTitle,
    breadcrumbs,
    currentProduct,
    isNew,
    features,
    currentVariant,
    isArchived,
    isValid,
    values,
    warehouses,
    setFieldValue,
    productId,
    loading,
    setLoading,
    history,
    fetchDeleteVariant,
    editVariant,
    handleSubmit,
    errors,
    showModal,
    setUnsavedStatus,
    handleExportMovements,
    eshops,
  } = props;

  return (
    <>
      <HeaderWrapper>
        <h4 className="page-title">{pageTitle}</h4>
        <Link className="back-link" to={breadcrumbs[breadcrumbs.length - 2].route}>
          <i className="fe-x" />
        </Link>
      </HeaderWrapper>
      <Wrapper className="row">
        <div className="card-box">
          <div className="row">
            <div className="col-12">
              <h4 className="header-title">Продукт</h4>
            </div>
          </div>
          <div className="row">
            <Link className="product-link" to="..">
              <img className="product-image" src={getProductImageUrl(currentProduct, 250)} />
              <h4 className="header-title card-name">{currentProduct.shortName}</h4>
              <p className="sub-header">{getItemVariantsString(currentProduct.variants.length)}</p>
            </Link>
          </div>
        </div>
        <MonoboxData
          isArchived={isArchived}
          isNew={isNew}
          isValid={isValid}
          product={currentProduct}
          variant={currentVariant}
          values={values}
          warehouses={warehouses}
          setFieldValue={setFieldValue}
          features={features}
          productId={productId}
          loading={loading}
          setLoading={setLoading}
          history={history}
          fetchDeleteVariant={fetchDeleteVariant}
          editVariant={editVariant}
          handleSubmit={handleSubmit}
          errors={errors}
          showModal={showModal}
          setUnsavedStatus={setUnsavedStatus}
          handleExportMovements={handleExportMovements}
          eshops={eshops}
        />
      </Wrapper>
    </>
  );
};

export default MobileLayout;
